import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AppErrors, ConflictError, NotFoundError } from '@fitness-force/models';;
import { environment } from '@fitness-force/environments';
import { map, catchError, throwError } from 'rxjs';
import { CONST_URL_SEGEMENTS } from '@fitness-force/constants';

@Injectable({
  providedIn: 'root',
})
export class PartnerService {
  private http = inject(HttpClient);
  private router = inject(Router);

  BASE_URL: string = environment.BASE_URL;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  // Charge Master
  getPartners(tenantId: number, allParams: Array<string> = []) {
    let parsedParams = new HttpParams()
    if (allParams.length > 0) {

      allParams.forEach((p: any) => {

        parsedParams = parsedParams.append(p.name, p.value);
      });
    }
    return this.http
      .get(
        environment.BASE_URL + CONST_URL_SEGEMENTS.PARTNER.GET_PARTNERS
          .replace('{tenant_id}', tenantId.toString()),
        { headers: this.httpOptions.headers, params: parsedParams }
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  getSinglePartner(tenantId: number, partner_id: number) {
    return this.http
      .get(
        environment.BASE_URL + CONST_URL_SEGEMENTS.PARTNER.GET_PARTNER_BY_ID
          .replace('{tenant_id}', tenantId.toString())
          .replace('{partner_id}', partner_id.toString()),
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  createPartner(tenantId: number, createPartner: any) {
    return this.http
      .post(
        environment.BASE_URL + CONST_URL_SEGEMENTS.PARTNER.CREATE_PARTNER
          .replace('{tenant_id}', tenantId.toString()),
        createPartner,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          if (error.status === 409) {
            return throwError(() => new ConflictError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  updatePartner(tenantId: number, partner_id: number, data: any) {
    return this.http
      .put(
        environment.BASE_URL + CONST_URL_SEGEMENTS.PARTNER.UPDATE_PARTNER
          .replace('{tenant_id}', tenantId.toString())
          .replace('{partner_id}', partner_id.toString()),
        data,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          if (error.status === 409) {
            return throwError(() => new ConflictError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }


}
